<div class="css3d-annotation-dialog">

  <!-- Toolbar - Konum Seçimi -->
  <div class="catia-toolbar">
    <div class="toolbar-grup">
      <div class="ayar-satir">
        <button class="catia-btn konum-btn" [class.active]="annotationPosition" (click)="annotasyonKonumuSec()">
          <i class="icon crosshairs"></i>
          {{annotationPosition ? 'Konum Seçildi' : 'Annotation Konumu Seç'}}
        </button>
      </div>
    </div>
  </div>

  <!-- Control Panel -->
  <div class="kontrol-paneli">

    <!-- Sekme 1: İçerik Ayarları -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="icerikAyarlariAcik = !icerikAyarlariAcik">
        <i class="icon file alternate outline"></i>
        <span>İçerik</span>
        <div class="chevron" [class.right]="!icerikAyarlariAcik" [class.down]="icerikAyarlariAcik"></div>
      </div>

      @if (icerikAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Başlık -->
        <div class="ayar-satir">
          <label>Başlık:</label>
          <input type="text" [(ngModel)]="baslik" (ngModelChange)="onizlemeGuncelle()"
                 class="catia-input" placeholder="Başlık...">
        </div>

        <!-- Açıklama -->
        <div class="ayar-satir">
          <label>Açıklama:</label>
          <textarea [(ngModel)]="aciklama" (ngModelChange)="onizlemeGuncelle()"
                    rows="3" class="catia-textarea" placeholder="Açıklama metni..."></textarea>
        </div>
      </div>
      }
    </div>

    <!-- Sekme 2: Bağlantı Noktaları -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="baglantilariAcik = !baglantilariAcik">
        <i class="icon sitemap"></i>
        <span>Bağlantı Noktaları</span>
        <div class="chevron" [class.right]="!baglantilariAcik" [class.down]="baglantilariAcik"></div>
      </div>

      @if (baglantilariAcik) {
      <div class="sekme-icerik">
        <!-- Connection Points List -->
        <div class="connection-points-list">
          @for (point of connectionPoints; track point.label; let i = $index) {
          <div class="connection-point-item">
            <span class="point-label">{{point.label}}</span>
            <button class="catia-btn mini-btn" [class.active]="point.position"
                    (click)="baglantiNoktasiSec(i)">
              <i class="icon map marker alternate"></i>
              {{point.position ? 'Seçildi' : 'Nokta Seç'}}
            </button>
            <button class="catia-btn delete-btn" (click)="baglantiSil(i)"
                    [disabled]="connectionPoints.length <= 1">
              <i class="icon trash"></i>
            </button>
          </div>
          }
        </div>

        <!-- Add Point Button -->
        <button class="catia-btn add-btn" (click)="baglantiEkle()"
                [disabled]="connectionPoints.length >= 8">
          <i class="icon plus"></i>
          Bağlantı Ekle
        </button>
      </div>
      }
    </div>

    <!-- Sekme 3: Görünüm Ayarları -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="gorunumAyarlariAcik = !gorunumAyarlariAcik">
        <i class="icon eye"></i>
        <span>Görünüm</span>
        <div class="chevron" [class.right]="!gorunumAyarlariAcik" [class.down]="gorunumAyarlariAcik"></div>
      </div>

      @if (gorunumAyarlariAcik) {
      <div class="sekme-icerik">
        <!-- Arka Plan Rengi -->
        <div class="ayar-satir">
          <label>Arka Plan:</label>
          <div class="renk-kontrol">
            <div class="renk-palette">
              @for (r of renkler; track r.kod) {
              <div class="renk-kutu" [style.background-color]="r.kod"
                   [class.secili]="arkaplanRengi === r.kod"
                   (click)="arkaplanRengi = r.kod; onizlemeGuncelle()"
                   [title]="r.isim"></div>
              }
            </div>
            <input type="color" [(ngModel)]="arkaplanRengi" (ngModelChange)="onizlemeGuncelle()" class="renk-input">
          </div>
        </div>

        <!-- Opaklık -->
        <div class="ayar-satir">
          <label>Opaklık:</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="arkaplanOpaklik" (ngModelChange)="onizlemeGuncelle()"
                   min="50" max="100" step="5">
            <span class="deger-gosterge">{{arkaplanOpaklik}}%</span>
          </div>
        </div>

        <!-- Çerçeve Rengi -->
        <div class="ayar-satir">
          <label>Çerçeve:</label>
          <div class="renk-kontrol">
            <input type="color" [(ngModel)]="cercevRengi" (ngModelChange)="onizlemeGuncelle()" class="renk-input">
            <input type="range" [(ngModel)]="cercevKalinlik" (ngModelChange)="onizlemeGuncelle()"
                   min="0" max="4" step="0.5" class="kalinlik-slider">
            <span class="deger-gosterge">{{cercevKalinlik}}px</span>
          </div>
        </div>

        <!-- Metin Rengi -->
        <div class="ayar-satir">
          <label>Metin:</label>
          <input type="color" [(ngModel)]="metinRengi" (ngModelChange)="onizlemeGuncelle()" class="renk-input">
        </div>

        <!-- Çizgi Rengi -->
        <div class="ayar-satir">
          <label>Çizgi:</label>
          <div class="renk-kontrol">
            <div class="renk-palette">
              @for (r of cizgiRenkleri; track r.kod) {
              <div class="renk-kutu" [style.background-color]="r.kod"
                   [class.secili]="cizgiRengi === r.kod"
                   (click)="cizgiRengi = r.kod; onizlemeGuncelle()"
                   [title]="r.isim"></div>
              }
            </div>
            <input type="color" [(ngModel)]="cizgiRengi" (ngModelChange)="onizlemeGuncelle()" class="renk-input">
          </div>
        </div>

        <!-- Çizgi Kalınlığı -->
        <div class="ayar-satir">
          <label>Çizgi Kalınlığı:</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="cizgiKalinlik" (ngModelChange)="onizlemeGuncelle()"
                   min="0.5" max="4" step="0.5">
            <span class="deger-gosterge">{{cizgiKalinlik}}px</span>
          </div>
        </div>

        <!-- Başlık Boyutu -->
        <div class="ayar-satir">
          <label>Başlık Boyutu:</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="baslikBoyut" (ngModelChange)="onizlemeGuncelle()"
                   min="10" max="24" step="1">
            <span class="deger-gosterge">{{baslikBoyut}}px</span>
          </div>
        </div>

        <!-- Açıklama Boyutu -->
        <div class="ayar-satir">
          <label>Açıklama Boyutu:</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="aciklamaBoyut" (ngModelChange)="onizlemeGuncelle()"
                   min="8" max="18" step="1">
            <span class="deger-gosterge">{{aciklamaBoyut}}px</span>
          </div>
        </div>

        <!-- Nokta Yarıçapı -->
        <div class="ayar-satir">
          <label>Nokta Boyutu:</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="noktaYaricap" (ngModelChange)="onizlemeGuncelle()"
                   min="6" max="16" step="1">
            <span class="deger-gosterge">{{noktaYaricap}}px</span>
          </div>
        </div>

        <!-- Sabit Boyut -->
        <div class="ayar-satir">
          <label>Sabit Boyut:</label>
          <div class="checkbox-kontrol">
            <input type="checkbox" [(ngModel)]="sabitBoyut" (ngModelChange)="sabitBoyutDegistir()"
                   id="sabitBoyutCSS3D" class="catia-checkbox">
            <label for="sabitBoyutCSS3D" class="checkbox-label">Zoom'dan Bağımsız</label>
          </div>
        </div>
      </div>
      }
    </div>

  </div>

  <!-- Action Bar -->
  <div class="aksiyon-bar">
    <button class="catia-btn ekle-btn" (click)="ekle()"
            [disabled]="!eklemeAktif">
      <i class="icon plus"></i>
      Ekle
    </button>
    <button class="catia-btn kapat-btn" (click)="kapat()">
      <i class="icon times"></i>
      Kapat
    </button>
  </div>

</div>
